import { render, staticRenderFns } from "./EditBranchModal.vue?vue&type=template&id=6f580c0d&scoped=true"
import script from "./EditBranchModal.vue?vue&type=script&lang=js"
export * from "./EditBranchModal.vue?vue&type=script&lang=js"
import style0 from "./EditBranchModal.vue?vue&type=style&index=0&id=6f580c0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f580c0d",
  null
  
)

export default component.exports